/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { GenericTextArea } from 'web-ui-components/lib/data/capture';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { referenceWrapperStyles } from './styles';
import withValidation from '../../../../containers/withValidation';
import withDescription from '../../../../containers/withDescription';
import { SmallestBody } from 'web-ui-components/lib/typography/body';

class Reference extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ref: props.chapsReference || props.reference,
		};
		this.handleChange = this.handleChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.chapsMode && this.props.chapsReference) {
			if (this.state.ref !== nextProps.chapsReference) this.setState({ ref: nextProps.chapsReference });
		} else if (this.state.ref !== nextProps.reference) this.setState({ ref: nextProps.reference });
	}

	onBlur() {
		if (this.props.reference !== this.state.ref) this.props.handleRefChange(this.state.ref);
		this.props.onBlur();
	}

	handleChange({ target: { value } }) {
		this.setState({ ref: this.props.cleanIllegalCharacters(value) });
	}

	render() {
		const {
			id,
			isReferenceFieldDisabled,
			content,
			onFocus,
			inputWrapClassName,
			copyRefToAll,
			isLongRef,
			referenceMaxLength,
		} = this.props;

		return (
			<div className={inputWrapClassName}>
				<span className={referenceWrapperStyles} role="button">
					{isLongRef ? (
						<GenericTextArea
							id={`field-reference-${id}`}
							value={this.state.ref}
							onChange={({ value }) => this.handleChange({ target: { value } })}
							maximumCharacters={Number(referenceMaxLength)}
							hideCharacterCount
							onBlur={this.onBlur}
							rowCount={10}
							isDisabled={isReferenceFieldDisabled}
							characterWidth={15}
						/>
					) : (
						<Input
							type="text"
							className="c-a-input c-a-input--text"
							id={`field-reference-${id}`}
							required=""
							aria-required="true"
							aria-invalid="true"
							value={this.state.ref}
							onChange={this.handleChange}
							onFocus={onFocus}
							onBlur={this.onBlur}
							disabled={isReferenceFieldDisabled}
							maxLength={referenceMaxLength}
							data-test-id="reference"
							aria-label="payment reference"
						/>
					)}
				</span>
				{copyRefToAll && (
					<div className="c-o-list-payment__input-wrap-text-link">
						<Button
							onClick={() => copyRefToAll(this.state.ref)}
							id="copy-ref-to-all-button"
							size="xs"
							disabled={!this.state.ref}
						>
							{content.copyToAllButton}
						</Button>
					</div>
				)}
				{isReferenceFieldDisabled && (
					<SmallestBody isFlush data-test-id="reference-disabled-message">
						{content.creditCardReferenceMsg}
					</SmallestBody>
				)}
			</div>
		);
	}
}
Reference.defaultProps = {
	reference: '',
};

Reference.propTypes = {
	id: PropTypes.string.isRequired,
	handleRefChange: PropTypes.func.isRequired,
	reference: PropTypes.string,
	isReferenceFieldDisabled: PropTypes.bool.isRequired,
	onFocus: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	content: PropTypes.shape({
		creditCardReferenceMsg: PropTypes.string.isRequired,
		copyToAllButton: PropTypes.string.isRequired,
	}),
	inputWrapClassName: PropTypes.string,
	copyRefToAll: PropTypes.func,
	isLongRef: PropTypes.bool,
	referenceMaxLength: PropTypes.string,
	cleanIllegalCharacters: PropTypes.func,
};

export { Reference };

export const ChapsReference = withValidation({
	validations: ['reference', 'referenceContent'],
	key: 'reference',
	message: {
		reference: 'Enter a reference for this payment',
		referenceContent: 'You can only use the following special characters / ? : ( ) . , ‘ + -',
	},
})(withDescription(Reference));

export default withValidation({
	validations: ['reference', 'referenceContent'],
	key: 'reference',
	message: {
		reference: 'Enter a reference for this payment',
		referenceContent: 'You can only use the following special characters / & ( ) . , ‘ - ',
	},
})(withDescription(Reference));
